import { render, staticRenderFns } from "./dicatamenOperativoVo.vue?vue&type=template&id=62feb2c1&scoped=true"
import script from "./dicatamenOperativoVo.vue?vue&type=script&lang=js"
export * from "./dicatamenOperativoVo.vue?vue&type=script&lang=js"
import style0 from "./dicatamenOperativoVo.vue?vue&type=style&index=0&id=62feb2c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62feb2c1",
  null
  
)

export default component.exports